// src/components/common/CookieBanner.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'antd';
import { toast } from 'react-toastify';

import { ROUTES } from '../../constants/routes';
import {
    getConsent,
    setConsent,
    CONSENT_ESSENTIAL,
    CONSENT_ALL,
} from '../../lib/cookieConsent';

export default function CookieBanner() {
    const intl = useIntl();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!getConsent()) setVisible(true);
    }, []);

    if (!visible) return null;

    const accept = () => {
        setConsent(CONSENT_ALL);
        toast.success(intl.formatMessage({ id: 'cookies.consent.saved' }));
        setVisible(false);
    };

    const reject = () => {
        setConsent(CONSENT_ESSENTIAL);
        toast.success(intl.formatMessage({ id: 'cookies.consent.saved' }));
        setVisible(false);
    };

    return (
        <div
            role="dialog"
            aria-live="polite"
            style={{
                position: 'fixed',
                bottom: 20,
                insetInlineStart: 20,
                insetInlineEnd: 20,
                maxWidth: 640,
                margin: '0 auto',
                zIndex: 9000,
                background: 'var(--home-card-bg)',
                border: '1px solid var(--home-card-border)',
                borderRadius: 12,
                padding: '16px 20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                display: 'flex',
                gap: 16,
                alignItems: 'center',
                flexWrap: 'wrap',
            }}
        >
            <div style={{ flex: 1, minWidth: 220, fontSize: 13, color: 'var(--home-fg-muted)', lineHeight: 1.6 }}>
                <FormattedMessage id="cookies.intro.body" />
                {' '}
                <Link to={ROUTES.COOKIES} style={{ color: 'var(--home-accent)' }}>
                    <FormattedMessage id="cookies.title" />
                </Link>
            </div>

            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <Button size="middle" onClick={reject}>
                    <FormattedMessage id="cookies.consent.reject" />
                </Button>
                <Button type="primary" size="middle" onClick={accept}>
                    <FormattedMessage id="cookies.consent.accept" />
                </Button>
            </div>
        </div>
    );
}